import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';

import { NotificationService } from 'src/app/Service/notification.service';

import { FormBuilder, FormControl, FormGroup, NgForm } from "@angular/forms";

import * as XLSX from 'xlsx';

import axios from "src/app/Service/axios";
import { GurdServiceService } from 'src/app/Service/gurd-service.service';


@Component({

  selector: 'app-presell-buffet',

  templateUrl: './presell-buffet.component.html',

  styleUrls: ['./presell-buffet.component.css']

})

export class PresellBuffetComponent implements OnInit {

  list_Presell: any = [];

  list_search: any = [];

  isLoading: boolean = false;

  dateFilter: FormGroup = this.FormBuilder.group({

    strDate: new FormControl('')

  })

  constructor(

    private router: Router,

    private FormBuilder: FormBuilder,

    private Notification: NotificationService,

    private gurdService: GurdServiceService

  ) { }

  ngOnInit(): void {

    this.tomorrowDate();

  }

  goBack() {

    this.router.navigate(['/'])

  }

  async search_Presell() {

    this.isLoading = true;

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      strDate: this.dateFilter.value.strDate

    }

    let res = JSON.parse((await axios.post(`Buffet_Prebuy_Report`, model)).data.toString());

    this.isLoading = false;

    this.list_Presell = res;

    this.list_search = res;

  }

  searchBy(search: any) {

    if (search.length > 2) {

      this.list_Presell = this.list_search.filter((el: any) => {

        return el.strTitle.includes(search);

      })
    }

    else if (search == '') this.list_Presell = this.list_search
  }

  exportExcel() {

    setTimeout(() => {

      let element = document.getElementById('Export_Excel');

      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

      const wb: XLSX.WorkBook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      XLSX.writeFile(wb, 'پیش فروش بوفه.xlsx');

    }, 200);

  }


  tomorrowDate() {

    var today = new Date();

    var tomorrow = new Date(today);

    tomorrow.setDate(today.getDate() + 1);

    const date = new Date(tomorrow).toLocaleDateString('fa-IR-u-nu-latn');

    const [year, month, day] = date.split('/');

    const formattedDate = `${year}/${month.padStart(2, '0')}/${day.padStart(2, '0')}`;

    this.dateFilter.controls['strDate'].setValue(formattedDate)

  }

}
